import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, Optional, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { BaseDialog } from '../base.dialog';
import { ClientInterface } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';

interface ConfirmContractResultDialogData {
    client: ClientInterface;
    success: boolean;
    redirectToPortal: boolean;
    isFirstContract: boolean;
}

@Component({
    templateUrl: './confirm-contract-result.dialog.html',
    styleUrls: ['./confirm-contract-result.dialog.scss'],
})
export class ConfirmContractResultDialog extends BaseDialog implements AfterViewInit, OnDestroy, OnInit {
    constructor(
        el: ElementRef,
        parentEvents: ParentEvents,
        renderer: Renderer2,
        private dialogRef: MatDialogRef<ConfirmContractResultDialog>,
        @Optional()
        @Inject(MAT_DIALOG_DATA)
        public data: ConfirmContractResultDialogData
    ) {
        super(parentEvents, el, renderer);
    }

    ngOnInit() {
        this.dialogRef.beforeClosed().subscribe(() => {
            this.onClick();
        });
    }

    onClick() {
        if (this.data.redirectToPortal) {
            this.parentEvents.cancel();
        } else {
            window.open('https://www.santaluciaam.es', '_self');
        }
    }
}
